
import { PillButton } from 'components/button';
import { COLOR } from 'constants/colors';
import React, { useEffect } from 'react'
import { Controller } from 'react-hook-form';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import { FormErrorMessageSpan } from 'views/common-styled-components';


interface InputProps extends React.AllHTMLAttributes<HTMLInputElement> {
    inputLabel: string | React.ReactElement,
    additionalText?: any,
    rules?: any,
    control: any,
    name: string,
    errors: any,
    variant?: 'line' | 'box',
    handleChange: Function,
    fontSize?: string,
    defaultAmounts?: any,
    setValue?: any
}

const InputContainer = styled.div<any>`
    margin-bottom: 24px;
    input {
        border: ${(props: any) => props.variant === 'line' ? 'none' : `solid 1px ${COLOR.LIGHTGREY}`};
        border-radius: 2px;
        background-color: transparent;
        padding: 10px;
        height: 40px;
        vertical-align: middle;
        -webkit-appearance: none;
        &:focus,&:active{
            background-color: transparent;

        }
    }
    .suggestedAmounsDev{
        display: flex;
        justify-content: space-between;
        flex-direction: ${(props: any) => !props.isMobile ? 'column' : 'row'};
        align-items: ${(props: any) => props.isMobile ? 'center' : ''};;
        gap: 4px;
    }
    .w700{
        width: 70%;
    }
    .sip-error{
        margin-top: 6px;
        margin-bottom: -20px !important;
    }
`
const PillAmountButton = styled(PillButton) <any>`
    box-shadow: 0px 0px 12px rgba(177, 197, 228, 0.45);

`

const CurrencyInput: React.FC<InputProps> = ({ name, inputLabel, handleChange, defaultValue, fontSize, placeholder, type, disabled, variant = 'box', errors, control, id, rules, defaultAmounts, setValue, ...rest }: InputProps) => {

    const isMobile = useMediaQuery({ maxWidth: 767 });

    const addCommas = (num: string) => num.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
    const removeNonNumeric = (num: string) => num.toString().replace(/[^0-9]/g, "");

    const formatNumber = (value: any) => {
        handleChange(value);
        setValue(name, value);
    }
    useEffect(() => {
        defaultValue && setValue(name, +defaultValue);
    }, [defaultValue])


    return (
        <div>
            <InputContainer variant={variant} isMobile={isMobile}>
                <label htmlFor={id}>{inputLabel}</label>
                <span className="currency-code" style={{ fontSize: fontSize }}>

                    <Controller
                        name={name}
                        control={control}
                        defaultValue={defaultValue ?? 0}
                        rules={rules}
                        render={({ onChange, value }) => {
                            const obj = new Intl.NumberFormat("en-IN");
                            const formattedNumber = () => {

                                return obj.format(Number(`${removeNonNumeric(value)}`));
                            }
                            return (
                                <>
                                    <input
                                        name={name}
                                        disabled={disabled}
                                        placeholder={placeholder}
                                        value={formattedNumber()}
                                        onChange={(event) => {
                                            onChange(Number(removeNonNumeric(event.target.value)?.replaceAll(",", "")));
                                            handleChange(Number(removeNonNumeric(event.target.value)?.replaceAll(",", "")));
                                        }}
                                        style={{ fontSize: fontSize }}
                                        {...rest}
                                    />
                                </>
                            );
                        }}
                    />
                </span>
                {(errors[name]) ? <div><FormErrorMessageSpan>{errors[name].message}</FormErrorMessageSpan> </div> : null}

                <div>
                    {
                        defaultAmounts && <>
                            <div className='suggestedAmounsDev'>
                                <p className='mt8 subgreyText'>Suggested {isMobile && <br/>}Amount</p>
                                <div className='disp-flex mt8 w700'>
                                    {defaultAmounts?.map((item: any, index: number) => (
                                        <PillAmountButton type="button" key={index}
                                            onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                                event.stopPropagation();
                                                ; formatNumber(item)
                                            }}>₹ {addCommas(item)}</PillAmountButton>
                                    ))
                                    }
                                </div>
                            </div>

                        </>
                    }
                </div>
            </InputContainer>
        </div>
    )
}

export default CurrencyInput

